// const fullPhoto = (pid, order) => `/api/photos/full_photo/${pid}/${order}`
const API = process.env.NEXT_PUBLIC_IMAGE_SERVICE
const fullPhoto = (pid, order) => `${API}/photo/${pid}/${order}`

module.exports = fullPhoto